export default "__VITE_ASSET__BLs9bPlN__"